var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 4a2.5 2.5 0 0 0-2 1L3.7 7.4A3.5 3.5 0 0 0 3 9.5v8A2.5 2.5 0 0 0 5.5 20h13a2.5 2.5 0 0 0 2.5-2.5v-8a3.5 3.5 0 0 0-.7-2.1L18.5 5a2.5 2.5 0 0 0-2-1h-9M11 5h2v3h-2zm-1 3V5H7.5a1.5 1.5 0 0 0-1.2.6L4.5 8zM4.05 9H10v1.5a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5V9h5.95a2.5 2.5 0 0 1 .05.5v8a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5v-8a2.5 2.5 0 0 1 .05-.5M19.5 8l-1.8-2.4a1.5 1.5 0 0 0-1.2-.6H14v3zM13 9v1.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V9zm-6.5 7a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgBox = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBox);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjUgNEM2LjcxMzExIDQgNS45NzIxNCA0LjM3MDQ5IDUuNSA1TDMuNyA3LjRDMy4yNDU2MiA4LjAwNTg0IDMgOC43NDI3IDMgOS41VjE3LjVDMyAxOC44ODA3IDQuMTE5MjkgMjAgNS41IDIwSDE4LjVDMTkuODgwNyAyMCAyMSAxOC44ODA3IDIxIDE3LjVWOS41QzIxIDguNzQyNyAyMC43NTQ0IDguMDA1ODQgMjAuMyA3LjRMMTguNSA1QzE4LjAyNzkgNC4zNzA0OSAxNy4yODY5IDQgMTYuNSA0SDEzLjVIMTAuNUg3LjVaTTExIDVIMTNWOEgxMVY1Wk0xMCA4VjVINy41QzcuMDI3ODYgNSA2LjU4MzI4IDUuMjIyMjkgNi4zIDUuNkw0LjUgOEgxMFpNNC4wNTA1MSA5SDEwVjEwLjVDMTAgMTEuMzI4NCAxMC42NzE2IDEyIDExLjUgMTJIMTIuNUMxMy4zMjg0IDEyIDE0IDExLjMyODQgMTQgMTAuNVY5SDE5Ljk0OTVDMTkuOTgyOSA5LjE2MzY0IDIwIDkuMzMxMTEgMjAgOS41VjE3LjVDMjAgMTguMzI4NCAxOS4zMjg0IDE5IDE4LjUgMTlINS41QzQuNjcxNTcgMTkgNCAxOC4zMjg0IDQgMTcuNVY5LjVDNCA5LjMzMTExIDQuMDE3MSA5LjE2MzY0IDQuMDUwNTEgOVpNMTkuNSA4TDE3LjcgNS42QzE3LjQxNjcgNS4yMjIyOSAxNi45NzIxIDUgMTYuNSA1SDE0VjhIMTkuNVpNMTMgOVYxMC41QzEzIDEwLjc3NjEgMTIuNzc2MSAxMSAxMi41IDExSDExLjVDMTEuMjIzOSAxMSAxMSAxMC43NzYxIDExIDEwLjVWOUgxM1pNNi41IDE2QzYuMjIzODYgMTYgNiAxNi4yMjM5IDYgMTYuNUM2IDE2Ljc3NjEgNi4yMjM4NiAxNyA2LjUgMTdIOS41QzkuNzc2MTQgMTcgMTAgMTYuNzc2MSAxMCAxNi41QzEwIDE2LjIyMzkgOS43NzYxNCAxNiA5LjUgMTZINi41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";